module.exports = __webpack_public_path__ + "static/media/Technologyicon01@2x.c9bed12e.png";